<div id="exists_cards">
<video autoPlay muted loop id="myVideobs">
  <source
    src="../../assets/videos/bs1.mp4"
    type="video/mp4"
  />
</video>

  <div class="cover">
    <section id="basicdetails" class="contact">
      <div class="container" data-aos="fade-up">
      <div class="row mt-1">
        <div class="row text-center">
        <div class="col form-group">
          <img src={{profileurl}} alt="profile" class="img-fluid img-prof"/>
        </div>
        </div>
        <div class="row text-center">
          <div class="col form-group">
            <h2 style="text-transform: uppercase;">{{userfirstname}} {{usermiddlename}} {{userlastname}}</h2>
            <h3>{{posdesig}}</h3>
            <h3>{{companyname}}</h3>
            <h5>{{address}}</h5>
          </div>
        </div>
      </div>
    </div>
    </section>
  </div>


  <section  id="counts" class="counts" style="margin-top: 150px;" id="contact">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2 class="text-center">Contact Us</h2>
      </div>

      <div class="container">

        <div class="row" data-aos="fade-up">

          <div class="col-lg-3 col-md-6">
            <div class="count-box">
              <i class="bi bi-geo-alt"></i>
              <span>Address</span>
              <p>{{address}}</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-md-0">
            <div class="count-box">
              <i class="bi bi-phone"></i>
              <span>Phone</span>
              <p><a href="tel:{{phoneshow}}">{{phoneshow}}</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="bi bi-phone-vibrate"></i>
              <span> Alternative</span>
              <p><a href="tel:{{aphone}}">{{aphone}}</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="bi bi-telephone"></i>
              <span>Landline </span>
            <p><a href="tel:{{landline}}">{{landline}}</a></p>
            </div>
          </div>

        </div>

      </div>
      <div class="container">
        <div class="row" data-aos="fade-up">
&nbsp;</div><div class="row" data-aos="fade-up">
  &nbsp;</div>
</div>

      <div class="container">

        <div class="row" data-aos="fade-up">

          <div class="col-lg-3 col-md-6">
            <div class="count-box">
              <i class="bi bi-telegram"></i>
              <span>Telegram </span>
              <p><a target="_blank" href="http://t.me/{{telegram}}">{{telegram}}</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-md-0">
            <div class="count-box">
              <i class="bi bi-whatsapp"></i>
              <span>whatsapp </span>
              <p><a target="_blank" href="https://wa.me/{{whatsapp}}">{{whatsapp}}</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="bi bi-envelope"></i>
              <span> Email</span>
              <p><a href="mailto:{{email}}">{{email}}</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="bi bi-globe"></i>
              <span>Website </span>
              <p><a href="{{website}}">{{website}}</a></p>
            </div>
          </div>

        </div>

      </div>

    </div>
  </section>

  <section class="section-sos section-services section-t8">
    <!-- <video autoPlay muted loop id="myVideobsos">
      <source
        src="../../assets/videos/sos.mp4"
        type="video/mp4"
      />
    </video> -->
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2 class="text-center">Social Medias</h2>
        </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex">
              <div class="card-box-ico" style="background: #3b5998 ;">
                <span style="color: #fff ;" class="bi bi-facebook"></span>
              </div>
              <div class="card-title-c align-self-center">
                <h2 style="color: #fff ;"  class="title-c">Facebook</h2>
              </div>
            </div>
            <div class="card-body-c">
              <!--  -->
            </div>
            <div class="card-footer-c text-center">
              <a href="{{facebook}}" target="_blank" class="link-c link-icon">goto facebook
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex" >
              <div class="card-box-ico" style="background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);" >
                <span style="color:white; " class="bi bi-instagram"></span>
              </div>
              <div class="card-title-c align-self-center">
                <h2 style="color:white; "  class="title-c">Instagram</h2>
              </div>
            </div>
            <div class="card-body-c">
            </div>
            <div class="card-footer-c text-center">
              <a href="{{instagram}}" class="link-c link-icon">goto instagram
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex">
              <div class="card-box-ico"  style="background: #3b5998 ;">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="100" fill="white" class="bi bi-messenger" viewBox="0 0 16 16">
                  <path d="M0 7.76C0 3.301 3.493 0 8 0s8 3.301 8 7.76-3.493 7.76-8 7.76c-.81 0-1.586-.107-2.316-.307a.639.639 0 0 0-.427.03l-1.588.702a.64.64 0 0 1-.898-.566l-.044-1.423a.639.639 0 0 0-.215-.456C.956 12.108 0 10.092 0 7.76zm5.546-1.459-2.35 3.728c-.225.358.214.761.551.506l2.525-1.916a.48.48 0 0 1 .578-.002l1.869 1.402a1.2 1.2 0 0 0 1.735-.32l2.35-3.728c.226-.358-.214-.761-.551-.506L9.728 7.381a.48.48 0 0 1-.578.002L7.281 5.98a1.2 1.2 0 0 0-1.735.32z"/>
                </svg>
              </div>
              <div class="card-title-c align-self-center">
                <h2 style="color: #fff ;"  class="title-c">Messenger</h2>
              </div>
            </div>
            <div class="card-body-c">
            </div>
            <div class="card-footer-c text-center">
              <a href="{{messenger}}" class="link-c link-icon">goto messenger
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
      &nbsp;
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex">
              <div class="card-box-ico" style="background: #00acee;">
                <span style="color: white;" class="bi bi-twitter"></span>
              </div>
              <div class="card-title-c align-self-center">
                <h2 style="color: white;"  class="title-c">Twitter</h2>
              </div>
            </div>
            <div class="card-body-c">
              <!--  -->
            </div>
            <div class="card-footer-c text-center">
              <a href="{{twitter}}" target="_blank" class="link-c link-icon">goto twitter
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex">
              <div class="card-box-ico" style="background: #FF0000;">
                <span style="color: white;"  class="bi bi-youtube"></span>
              </div>
              <div class="card-title-c align-self-center">
                <h2 style="color: white;"  class="title-c">Youtube</h2>
              </div>
            </div>
            <div class="card-body-c text-center">
            </div>
            <div class="card-footer-c text-center">
              <a href="{{youtube}}" class="link-c link-icon">goto youtube
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-box-c foo">
            <div class="card-header-c d-flex">
              <div class="card-box-ico"  style="background: #0072b1;">
                <span  style="color: #ffff;" class="bi bi-linkedin"></span>

              </div>
              <div class="card-title-c align-self-center">
                <h2  style="color: #ffff;" class="title-c">LinkedIn</h2>
              </div>
            </div>
            <div class="card-body-c ">
            </div>
            <div class="card-footer-c text-center">
              <a href="{{linkedin}}" class="link-c link-icon">goto linkedin
                <span class="bi bi-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="payment" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Payments</h2>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

            <div class="row">
              <div class="col-md-3 form-group">
                <a href="{{gpay}}"><img src="../../assets/img/gpay.jpg" class="pay-ic"/></a>
              </div>
              <div class="col-md-3 form-group">
                <a href="{{phonepe}}"><img src="../../assets/img/phone-pe.png" class="pay-ic"/></a>
              </div>
        <h3>Bank Account details.</h3>

              <div class="col-md-3 form-group">
                <h6>{{bankname}}</h6>
              </div>
              <div class="col-md-3 form-group">
                <h6>{{accountnumber}}</h6>
              </div>
              <div class="col-md-3 form-group">
                <h6>{{ifsc}}</h6>
              </div>
              <div class="col-md-3 form-group">
                <h6>{{accountholdername}}</h6>
              </div>
              <div class="col-md-3 form-group">
                <h6>{{savingscurrent}}</h6>
            </div>
</div>
        </div>

      </div>

    </div>
  </section>
  <section class="contact" style="background: #0072b1;">
    <div class="container">
      <div class="row">
        <div class="col-md-6 section-title">
          <h2 style="color: #fff;">Enquiry</h2>

        </div>
        <div class="col-md-6 section-title">
          <h2 style="color: #fff;">About Us</h2>

        </div>
        <div class="col-sm-6 section-t8">
          <div class="row">
            <div class="col-md-6 php-email-form">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="form-group">
                      <input type="text" name="name" #enqname class="form-control form-control-lg form-control-a" placeholder="Your Name" required>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group">
                      <input name="email" type="email" #enqemail class="form-control form-control-lg form-control-a" placeholder="Your Email" required>
                    </div>
                  </div>
                  </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <input type="text" name="subject" #enqsubject class="form-control form-control-lg form-control-a" placeholder="Subject" required>
                    </div>
                  </div>
                  </div>
                <div class="row">

                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea name="message" class="form-control" #enqmes name="message" cols="45" rows="8" placeholder="Message" required></textarea>
                    </div>
                  </div>
                  </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                      <button type="submit"
                      (click)='enq_email(enqname.value,enqemail.value,enqsubject.value,enqmes.value)'
                      class="btn btn-a">Send Message</button>
                  </div>
                </div>
            </div>

          </div>
        </div>
        <div class="col-md-6 section-t8">
          <div class="row">
            <div class="col-md-12 form-group text-center">

              <div class="form-group mt-3">
                <h6>{{abtus}}</h6>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="gallery" class="gallery">
    <div class="container">

      <div class="section-title" data-aos="fade-up">
        <h2>Gallery</h2>
        <p>Check our Gallery</p>
      </div>

      <div class="row no-gutters" data-aos="fade-left">

        <div class="col-lg-3 col-md-4 " *ngFor="let i of gallery_urls">
          <div *ngIf="i">
          <div class="gallery-item" data-aos="zoom-in" data-aos-delay="100">
            <a href="{{i[0]}}" data-toggle="lightbox" data-gallery="gallery" class="gallery-lightbox">
              <img src="{{i[0]}}" alt="" class="img-fluid">
            </a>
          </div>
          </div>
        </div>
      </div>

    </div>
  </section>


  <section id="team" class="team">
    <video autoPlay muted loop id="myVideobsos">
      <source
        src="../../assets/videos/header1.mp4"
        type="video/mp4"
      />
    </video>
    <div class="container">

      <div class="section-title" style="margin-top: 50px;" data-aos="fade-up">
        <h2 style="color: white;">Products & Services</h2>
        <p style="color: white;">See Our Products & Services</p>
      </div>

      <div class="row" data-aos="fade-left">

        <div class="col-lg-3 col-md-6" *ngFor="let i of pands_urls">
          <div *ngIf="i">
          <div class="member" style="margin-top:10px;" data-aos="zoom-in" data-aos-delay="100">
            <div class="pic"><img src="{{i[2]}}" class="img-fluid" alt=""></div>
            <div class="member-info">
              <h4>{{i[0]}}</h4>
              <span>{{i[1]}}</span>
            </div>
          </div>
          </div>
        </div>


      </div>

    </div>
  </section>
</div>
